import { Quiz } from 'platform-components';
import React from 'react';

export const QuizPage = () => (
    <>
        <div className="quiz-page">
            <Quiz />
        </div>
    </>
);
